var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"mega-menu__overlay",style:(_vm.height)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }